import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';

import * as dashboardActions from "store/entities/dashboard/action";
import * as infoActions from "store/entities/settingsInfo/action";
import * as accountActions from "store/auth/account/action";

import NumberFormat, { NumberFormatRemove } from "utils/numberFormat-legacy";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import validate from "utils/validate";
import PageContent from "components/__new/common/PageContent";
import Maybe from "components/__new/common/Maybe";
import { ButtonLoader } from "components/__new/common/form";
import useMediaService from "hooks/useMediaService";
import useEmployerProducts from 'hooks/useEmployerProducts';
import useInlinePageRouter from "components/__new/general/useInlinePageRouter";
// import companytestpic from "assets/images/logos/vw-test-pic.svg";
import {  convertToTitleCase } from "utils/stringFormatter";
import pen from "assets/images/icons/pen-icon.svg";
import helpcircle from "assets/images/icons/help-circle.svg";
import nigerianflag from "assets/images/icons/nigeria-flag-icon.svg";
import CompanyProfileModal from "components/__new/common/form/CompanyProfileModal";
import CompanyInfoModal from "components/__new/common/form/CompanyInfoModal";
import CompanyContactInfoModal from 'components/__new/common/form/CompanyContactInfoModal';
import useLoginInfo from 'hooks/useLoginInfo';
import Table from 'components/__new/common/Table';
import { getBusinessInitials } from 'utils/nameInitials.jsx';
import { ReactComponent as IconLink } from "assets/images/icons/link.svg";
import pencilIcon from "assets/images/icons/pencil-icon.svg";




const CompanyDetails = () => {
    const dispatch = useDispatch();
    const { userInfo } = useLoginInfo();
    const { uploadFile, uploadLoading } = useMediaService();
    const { companyInfoLoading, companyInfoApi,  updateLegalInfoLoading, updateLegalInfoSuccess } = useSelector((s) => s.entities.settingsInfo);
    const {dashboard} = useSelector(state => state.entities.dashboard);
    const {employerInfo, employerInfoLoading} = useSelector(state => state.auth.account);
    const website = employerInfo?.data?.employer?.company?.socials?.website
    const companyInfo = employerInfo?.data?.employer?.company
    const { isOnDemandUser } = useEmployerProducts();

    const [companyLogoImage, setCompanyLogoImage] = useState('');


useEffect(() => {
    setCompanyLogoImage(companyInfo?.businessLogo)
}, [employerInfo])



    const [editCompanyInfo, setEditCompanyInfo] = useState(false);
    const [savedCompanyInfo, setSavedCompanyInfo] = useState();
    const [form, setForm] = useState({
        companyName: "",
        estimatedEmployees: "",
        industry: "",
        rcNumber: "",
        tinNumber: "",
        address: "",
        country: "",
        website: "",
        invoiceEmail: "",
        estimatedSalary: "",

        legalContact: {
            name: "",
            email: "",
        },
        supportContact: {
            name: "",
            email: "",
        },
    })
    const [businessDocumentUpload, setBusinessDocumentUpload] = useState([]);
    const [businessLogoUpload, setBusinessLogoUpload] = useState([]);
    const [isDocumentDeleted, setIsDocumentDeleted] = useState({
        action: false,
        type: "",
        file: "",
    });
    
    const companyName = companyInfo?.companyName


    const submitForm = async e => {
        e.preventDefault();

        const validateForm = {...form};
        delete validateForm["legalContact"];
        delete validateForm["website"];
        delete validateForm["industry"];
        delete validateForm["supportContact"];
        delete validateForm["businessDocuments"];
        delete validateForm["businessLogo"];
        delete validateForm["country"];
        
        if(isOnDemandUser === false) {
            delete validateForm["invoiceEmail"];
        }
        
        const errorsForm = validate(validateForm) || {};
        const errorsLegalContact = validate(form.legalContact) || {};
        const errorsSupportContact = validate(form.supportContact) || {};
        
        let errors = {};
        
        if(isOnDemandUser) {
            errors = {...errorsForm, ...errorsLegalContact, ...errorsSupportContact};
        } else {
            errors = {...errorsForm, ...errorsSupportContact};
        }

        if (Object.keys(errors).length > 0){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            initiateSubmit({
                form: form,
                saveNewUploads: true,
            });
        }
    }


    const initiateSubmit = async (data) => {
        const params = {
            ...data.form,
            estimatedSalary: NumberFormatRemove(data.form.estimatedSalary),
            legalContact: {
                ...data.form.legalContact,
                email: data.form.invoiceEmail,
            }
        };


        let businessDocuments = data?.form?.businessDocuments || [];
        let businessLogo = data?.form?.businessLogo || "";


        if (data.saveNewUploads === true){
            if (businessDocumentUpload.length > 0){
                for (let i = 0; i < businessDocumentUpload.length; i++){
                    const response = await uploadFile(businessDocumentUpload[i]);
                    if (response?.status === "success"){
                        businessDocuments.push(response?.data?.url || "");
                    }
                    else{
                        toast.error(businessDocumentUpload[i]?.name + " could not be uploaded");
                    }
                }
            }


            if (businessLogoUpload.length === 1){
                const response = await uploadFile(businessLogoUpload[0]);
                if (response?.status === "success"){
                    businessLogo = response?.data?.url || "";
                }
                else{
                    toast.error("Unable to upload company logo");
                }
            }
            else if (businessLogoUpload.length > 1){
                toast.error("Please select ONE file for the company's logo");
            }
        }


        const paramsPayload = {
            companyName: params.companyName,
            estimatedEmployees: params.estimatedEmployees,
            rcNumber: params.rcNumber,
            tinNumber: params.tinNumber,
            address: params.address,
            invoiceEmail: params.invoiceEmail,
            estimatedSalary: params.estimatedSalary,
            industry: params.industry,
            country: params.country,
            website: params.website,
            legalContact: params.legalContact,
            supportContact: params.supportContact,
            businessDocuments: businessDocuments,
            businessLogo: businessLogo,
        }
        dispatch(infoActions.editLegalInfo(paramsPayload));
    }


    const processFormSuccess = () => {
        if (isDocumentDeleted.action === true){
            if (isDocumentDeleted.type === "logo"){
                setSavedCompanyInfo({
                    ...savedCompanyInfo,
                    businessLogo: "",
                });
                setForm({
                    ...form,
                    businessLogo: "",
                });
            }
            else if (isDocumentDeleted.type === "business document"){
                setSavedCompanyInfo({
                    ...savedCompanyInfo,
                    businessDocuments: savedCompanyInfo.businessDocuments.filter(doc => doc !== isDocumentDeleted.file),
                });
                setForm({
                    ...form,
                    businessDocuments: form.businessDocuments.filter(doc => doc !== isDocumentDeleted.file),
                });
            }

            setIsDocumentDeleted({
                action: false,
                type: "",
                file: "",
            });
        }
        else{
            setEditCompanyInfo(false);
            if (companyInfoLoading === false){
                dispatch(infoActions.getInfo(userInfo?.company?.selectedCompanyId));
            }
        }
    }
    
    const { InlineRouterTab } = useInlinePageRouter();
    const [isOpenCompanyProfileModal, setIsOpenCompanyProfileModal] = useState(false);
    const [editCompanyInfoModal, setEditCompanyInfoModal] = useState(false);
    const [editCompanyContactInfoModal, setEditCompanyContactInfoModal] = useState(false);

    const handleOpenCompanyProfileModal = () => { 
        if(dashboard?.member?.userType === "employer"){
            if(isOpenCompanyProfileModal === false){
                setIsOpenCompanyProfileModal(true);
            } else {
                setIsOpenCompanyProfileModal(false);
            }
        }
     }
    
    const queryOptions = [
        {
            title: "Profile Information",
            path: "/settings/profile"
            
        },
        {
            title: "Company Details",
            path: "/settings/info"           
        },
        {
            title: "Teams",
            path: "/settings/team-management",
            
        },
        {
            title: "Role Management",
            path: "/settings/team-management/roles",
            
        },
        {
            title: "On-Demand Pay",
            path: "/settings/ondemand-pay",
            
        },
        {
            title: "Login & Security",
            path: "/settings/login-security",
           
        },
        // {
        //     title: "Notifications",
        //     path: "/settings/notifications",
           
        // },
    ]

    useEffect(() => {
        dispatch(infoActions.getInfo(userInfo?.company?.selectedCompanyId));
        dispatch(dashboardActions.getDashboard())
        dispatch(accountActions.getEmployerInfo())
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        dispatch(infoActions.getInfo(userInfo?.company?.selectedCompanyId));
        // eslint-disable-next-line
    }, [companyLogoImage])
    



    useEffect(() => {
        if (updateLegalInfoSuccess === true){
            processFormSuccess();
        }
        // eslint-disable-next-line
    }, [updateLegalInfoSuccess]);


    useEffect(() => {
        if (companyInfoApi?.status === "success"){
            const info = {
                companyName: companyInfo?.companyName || "",
                estimatedEmployees: companyInfo?.estimatedEmployees?.toString() || "",
                industry: companyInfo?.industry || "",
                rcNumber: companyInfo?.rcNumber || "",
                tinNumber: companyInfo?.tinNumber || "",
                address: companyInfo?.address || "",
                country: companyInfo?.country || "",
                website: employerInfo?.data?.employer?.company?.socials?.website || "",
                invoiceEmail: companyInfo?.invoiceEmail || "",
                estimatedSalary: NumberFormat(companyInfo?.estimatedSalary?.toFixed(2)) || "",

                legalContact: {
                    name: companyInfo?.legalContact?.name || "",
                    email: companyInfo?.legalContact?.email || companyInfo?.invoiceEmail,
                },
                supportContact: {
                    name: companyInfo?.supportContact?.name || "",
                    email: companyInfo?.supportContact?.email || "",
                },

                businessDocuments: companyInfo?.businessDocuments || [],
                businessLogo: companyInfo?.businessLogo || "",
            }
            setSavedCompanyInfo(info);
            setForm({
                ...form,
                ...info,
            });
        }
        // eslint-disable-next-line
    }, [companyInfoApi]);
    

    return ( 
        <div>
            
            <DynamicHeadTag
                headerText="Company | Settings"
                headerDescription="Customize your account preferences, including account information, security and privacy settings, notifications, and other account-related options."
            />

            <CompanyProfileModal
                isOpen={isOpenCompanyProfileModal}
                setIsOpen={setIsOpenCompanyProfileModal}
                handleImgUpdate={(imgString) => setCompanyLogoImage(imgString)}
                company={employerInfo?.data?.employer?.company}
            />
            
            <CompanyInfoModal 
            isOpen={editCompanyInfoModal}
            setIsOpen={setEditCompanyInfoModal}
            company={employerInfo?.data?.employer?.company}
            />
            
            <CompanyContactInfoModal 
            isOpen={editCompanyContactInfoModal}
            setIsOpen={setEditCompanyContactInfoModal}
            company={employerInfo?.data?.employer?.company}
            />

            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title text-ep-deep-dark">
                        Settings
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
            </div>


            <div className="mt-6 w-full">
                <InlineRouterTab
                    items={queryOptions}
                />
            </div>

            <div  className="mt-6 p-4 sm:p-6 bg-white" style={{borderRadius: '12px'}}>
                

                    <div className="max-w-full">
                        <form onSubmit={submitForm}>
                            <h3 style={{ fontSize: '18px', lineHeight: '28px' }}  className="font-bold text-ep-black">
                                Company Details
                            </h3>
                            <PageContent
                                loading={employerInfoLoading}
                                data={employerInfo}
                                loadingText="Loading company information..."
                                emptyText="Company information not found"
                                errorText="Unable to fetch company information"
                            />
                            <Maybe condition={employerInfoLoading === false && employerInfo?.status === "success"}>
                                <div className='border border-ep-rule p-6 rounded-md mt-5'>
                                <Table className="w-full mb-6">
                                    <Table.Head>
                                        <th style={{border: '0px', padding: '12px 0px', backgroundColor: 'transparent', color: "#1A202C",  fontWeight: 500, width: "263px", fontSize: '16px', lineHeight: '19.2px', paddingRight: '64px'
                                        }} className="border-transparent">Company Logo</th>
                                        <th style={{border: '0px', backgroundColor: 'transparent', fontSize: '16px', lineHeight: '18.24px', padding: '12px 0px', paddingRight: '64px'}} className="font-normal text-left text-ep-gray-600">Add a Logo to personalize your company</th>
                                        <th style={{border: '0px', backgroundColor: 'transparent', width: '100%', display: 'flex', justifyContent: "flex-end",   fontSize: '16px', lineHeight: '21px', padding: '12px 0px' }} className="font-medium relative">
                                            <button type='button' style={{right: '0px', top: '10px'}} className="rounded-full flex justify-center border-1 border-ep-primary-50 items-center bg-ep-primary-600 text-sm absolute  z-10 w-4 h-4  font-normal text-white" onClick={handleOpenCompanyProfileModal}>
                                                <img className=' cursor-pointer w-2 h-2' src={pencilIcon} alt="edit" />
                                            </button>
                                            <button type='button' className='cursor-pointer flex items-center ' onClick={handleOpenCompanyProfileModal}>
                                                {!companyLogoImage ? 
                                                            <div className='flex justify-center items-center rounded-full text-center text-white bg-ep-primary'
                                                            style={{
                                                                borderRadius: '50%',
                                                                width: '48px',
                                                                height: '48px',
                                                                fontSize: "20px",
                                                            }}>
                                                            {getBusinessInitials(companyName)}
                                                        </div>
                                                : <img 
                                                    // className='h-12 w-12' 
                                                    src={companyInfo?.businessLogo || companyLogoImage} 
                                                    alt="user avatar" 
                                                    style={{
                                                        borderRadius: '50%',
                                                        width: '48px',
                                                        height: '48px',
                                                        objectFit: 'cover',
                                                    }}
                                                />}
                                            </button>
                                        </th>
                                    </Table.Head>
                                </Table>
                                            
                                <hr className='my-8 border border-ep-rule'/>
                                
                                <Table className="w-full mb-6">
                                    <Table.Head>
                                        <th 
                                            style={{
                                                border: '0px', 
                                                backgroundColor: 'transparent',  
                                                fontSize: '16px', 
                                                lineHeight: '18.24px',
                                                padding: '12px 0px',
                                                width: '263px',
                                                paddingRight: '64px',
                                                fontWeight: 500
                                            }} 
                                            className="border-transparent text-ep-gray-300 font-medium"
                                        >
                                            Company Info
                                        </th>
                                        <th 
                                            style={{
                                                border: '0px', 
                                                backgroundColor: 'transparent', 
                                                fontSize: '16px', 
                                                lineHeight: '18.24px',
                                                padding: '12px 0px',
                                                paddingRight: '64px'
                                            }} 
                                            className="font-normal text-left text-ep-gray-600"
                                        >
                                            Manage your company's information
                                        </th>
                                        <th 
                                            style={{
                                                border: '0px', 
                                                backgroundColor: 'transparent', 
                                                width: '100%', 
                                                display: 'flex', 
                                                justifyContent: "flex-end", 
                                                padding: '12px 0px',
                                                fontSize: '16px', 
                                                lineHeight: '21px'
                                            }} 
                                            className="font-medium"
                                        >
                                            {dashboard?.member?.userType === "employer" && <button 
                                                type="button" 
                                                // style={{paddingLeft: '16px'}}
                                                className="text-ep-primary font-medium underline flex justify-end text-right" 
                                                onClick={() => setEditCompanyInfoModal(true)}
                                            >
                                                <img src={pen} alt="pen-icon"/>Edit
                                            </button>}
                                        </th>
                                    </Table.Head>
                                </Table>
                                <Table>
                                    <Table.Body>
                                        <div className="flex flex-col lg:flex-row w-full">
                                            <div className="left lg:flex-1">
                                                <tr style={{width: '263px'}}>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', width: '263px',  paddingRight: '64px'}} className="">Company Name</td>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px', width: '241px',  paddingRight: '64px' }} className="font-medium">{convertToTitleCase(companyInfo?.companyName)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', width: '263px'}} className="">No. of Employees</td>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px', width: '241px',  paddingRight: '64px'  }}className="font-medium">{companyInfo?.estimatedEmployees}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', width: '263px' }} className="">Industry</td>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px', width: '241px',  paddingRight: '64px'  }} className="font-medium">{convertToTitleCase(companyInfo?.industry)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', width: '263px' }} className=""><div className="flex">Business Reg. No. <img className='pl-2' src={helpcircle} alt="" /></div></td>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px', width: '241px',  paddingRight: '64px'  }} className="uppercase font-medium">{companyInfo?.registrationNumber}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', width: '263px' }} className=""><div className="flex">Tax Identification No <img className='pl-2' src={helpcircle} alt="" /></div></td>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px', width: '241px',  paddingRight: '64px'  }} className="uppercase font-medium">{companyInfo?.taxIdentificationNumber || '-' }</td>
                                                </tr>
                                            </div>
                                            <div className="right lg:flex-1">
                                            <tr>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', width: '263px',  paddingRight: '64px'}} className="">Address</td>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px', width: '241px'  }} className="font-medium ellipsis">{convertToTitleCase(companyInfo?.address)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', width: '263px',  paddingRight: '64px'}} className="">Country</td>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px', width: '241px'  }}className="font-medium"><div className=' flex'><img src={nigerianflag} alt="" /><span className='pl-2 '>{convertToTitleCase(companyInfo?.country || '-')}</span></div></td>
                                                </tr>
                                                <tr>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', width: '263px',  paddingRight: '64px' }} className="">Website</td>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#00535C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px', width: '241px'  }} className="font-medium text-ep-primary-600"> {employerInfo?.status === "success" ? 
                                                        <a href={website} className="flex items-center"> <IconLink className="text-ep-primary-600" /> {website}</a> 
                                                        : '-'}</td>
                                                </tr>
                                            </div>
                                        </div>
                                    </Table.Body>
                                </Table>
                                
                                <hr className='my-8 border border-ep-rule'/>
                                                                
                                <Table className="w-full mb-6">
                                    <Table.Head>
                                        <th 
                                            style={{
                                                border: '0px', 
                                                backgroundColor: 'transparent',  
                                                width: "263px", 
                                                fontSize: '16px', 
                                                lineHeight: '18.24px',
                                                marginRight: '64px',
                                                padding: '12px 0px',
                                                fontWeight: 500
                                            }} 
                                            className="border-transparent bg-ep-primary-300 text-ep-gray-300 font-medium"
                                        >
                                            Contact Info
                                        </th>
                                        <th 
                                            style={{
                                                border: '0px', 
                                                backgroundColor: 'transparent', 
                                                fontSize: '16px', 
                                                padding: '12px 0px',
                                                lineHeight: '18.24px'
                                            }} 
                                            className="font-normal text-left text-ep-gray-600"
                                        >
                                            Manage your company’s contact information
                                        </th>
                                        <th 
                                            style={{
                                                border: '0px', 
                                                backgroundColor: 'transparent', 
                                                width: '100%', 
                                                display: 'flex', 
                                                justifyContent: "flex-end", 
                                                padding: '12px 0px',
                                                fontSize: '16px', 
                                                lineHeight: '21px'
                                            }} 
                                            className="font-medium"
                                        >
                                            {dashboard?.member?.userType === "employer" && <button 
                                                type="button" 
                                                className="text-ep-primary font-medium underline flex justify-end text-right" 
                                                onClick={() => setEditCompanyContactInfoModal(true)}
                                            >
                                                <img src={pen} alt="pen-icon"/>Edit
                                            </button>}
                                        </th>
                                    </Table.Head>
                                    <Table.Body>
                                                <tr>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', width: '199px' , paddingRight: '64px'}} className=""><div className='flex'>Primary Contact Person <img className='pl-2' src={helpcircle} alt="" /></div></td>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px' }}className="font-medium">{convertToTitleCase(companyInfo?.primaryContactPerson) || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', width: '199px' }} className=""><div className='flex'>Primary Contact's Email <img className='pl-2' src={helpcircle} alt="" /></div></td>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px' }} className="font-medium">{companyInfo?.primaryContactEmail || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', width: '199px' }} className="">Secondary Contact Person</td>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px' }} className="font-medium">{convertToTitleCase(companyInfo?.secondaryContactPerson)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#4A5564', fontSize: '16px', lineHeight: '18.24px', width: '199px' }} className="">Secondary Contact's Email</td>
                                                    <td style={{border: '0px solid transparent', padding: '12px 0px', color: '#1A202C', fontWeight: 500, fontSize: '16px', lineHeight: '18.24px' }} className="font-medium">{companyInfo?.secondaryContactEmail || '-'}</td>
                                                </tr>
                                    </Table.Body>
                                </Table>
                                </div>
                            </Maybe>

                            <Maybe condition={editCompanyInfo === true}>
                                <div className="mt-8 flex space-x-4">
                                    <ButtonLoader type="submit" loading={uploadLoading || updateLegalInfoLoading} className="btn btn-ep-primary">
                                        Update Company Info
                                    </ButtonLoader>
                                    <button type="button" onClick={() => setEditCompanyInfo(false)} className="btn btn-transparent-primary">
                                        Cancel
                                    </button>
                                </div>
                            </Maybe>

                        </form>
                    </div>
            </div>

        </div>
    )
}


export default CompanyDetails;
